import {Component, Injector, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {Utilities} from '../../utilities/utilities.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CalendarHeaderComponent} from '@shared/components/calendar-header/calendar-header.component';
import {DateUtilities} from '@shared/utilities/date-utilities.model';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-general-message-dialog',
	templateUrl: './general-message-dialog.component.html',
	styleUrls: ['./general-message-dialog.component.scss']
})
export class GeneralMessageDialogComponent implements OnInit {
	static CLOSE_BY_CTA: string = 'closeByCta';

	titleWarning: string = GeneralMessageModel.TITLE_WARNING;
	titleWarningDeleteTagAlert: string = GeneralMessageModel.TITLE_WARNING_DELETE_TAG_ALERT;
	titleCanNotDelivery: string = GeneralMessageModel.TITLE_CAN_NOT_DELIVERY;
	titleCreatingCertificate: string = GeneralMessageModel.TITLE_CREATING_CERTIFICATE;
	titleReleasesFeedback: string = GeneralMessageModel.TITLE_RELEASES_FEEDBACK;
	titleCCAldImportMassiveContractChangePage: string = GeneralMessageModel.TITLE_CC_ALD_IMPORT_MASSIVE_CONTRACT_CHANGE_PAGE;

	txtAutomaticMessageWarning: string = GeneralMessageModel.TXT_AUTOMATIC_MESSAGE_WARNING;
	txtCreatingCertificate: string = GeneralMessageModel.TXT_CREATING_CERTIFICATE;
	txtReleasesFeedBack: string = GeneralMessageModel.TXT_RELEASES_FEEDBACK;
	txtIsNotIR: string = GeneralMessageModel.TXT_IS_NOT_IR;
	txtDeleteGeneratedDeliveryCertificate: string = GeneralMessageModel.TXT_DELETE_GENERATED_DELIVERY_CERTIFICATE;
	txtDeleteGeneratedClosingCertificate: string = GeneralMessageModel.TXT_DELETE_GENERATED_CLOSING_CERTIFICATE;
	txtDeleteTagAlert: string = GeneralMessageModel.TXT_DELETE_TAG_ALERT;
	txtCCAldImportMassiveContractChangePage: string = GeneralMessageModel.TXT_CC_ALD_IMPORT_MASSIVE_CONTRACT_CHANGE_PAGE;
	txtDeleteEntity: string = GeneralMessageModel.TXT_DELETE_ENTITY;
	txtConfirmCenter: string = GeneralMessageModel.TXT_CONFIRM_CENTER;

	txtCCSpStartReportSpot: string = GeneralMessageModel.TXT_CC_SP_START_REPORT_SPOT;

	txtAttachmentsConfirmDelete: string = GeneralMessageModel.TXT_ATTACHMENTS_CONFIRM_DELETE;

	txtCCSuspendSurvey: string = GeneralMessageModel.TXT_CC_SUSPEND_SURVEY;
	txtCCSpoConfirmTerminationContract: string = GeneralMessageModel.TXT_CC_SPO_CONFIRM_TERMINATION_CONTRACT;
	txtCCDkoChangeNumTyres: string = GeneralMessageModel.TXT_CC_DKO_CHANGE_NUM_TYRES;
	txtCCSpChangeTab: string = GeneralMessageModel.TXT_CC_SP_CHANGE_TAB;
	txtCCDkoDeleteDamage: string = GeneralMessageModel.TXT_CC_DKO_DELETE_DAMAGE;

	txtAuthorityAddAcceptanceReport: string = GeneralMessageModel.TXT_AUTHORITY_ADD_ACCEPTANCE_REPORT;
	txtAuthorityCantRemoveAcceptanceReport: string = GeneralMessageModel.TXT_AUTHORITY_CANT_REMOVE_ACCEPTANCE_REPORT;

	txtButtonGoToAlert: string = GeneralMessageModel.TXT_BUTTON_GO_TO_ALERT;
	txtButtonGoToOrder: string = GeneralMessageModel.TXT_BUTTON_GO_TO_ORDER;
	txtButtonSaveAndGoToOrder: string = GeneralMessageModel.TXT_BUTTON_SAVE_AND_GO_TO_ORDER;
	txtButtonBlockCreatuingCertificate: string = GeneralMessageModel.TXT_BUTTON_BLOCK_CREATING_CERTIFICATE;
	txtButtonFeedback: string = GeneralMessageModel.TXT_BUTTON_FEEDBACK;
	txtButtonAcceptDeleteGeneratedDeliveryCertificate: string = GeneralMessageModel.TXT_BUTTON_ACCEPT_DELETE_GENERATED_DELIVERY_CERTIFICATE;
	txtButtonDeclineDeleteGeneratedDeliveryCertificate: string = GeneralMessageModel.TXT_BUTTON_DECLINE_DELETE_GENERATED_DELIVERY_CERTIFICATE;
	txtButtonAcceptDeleteGeneratedClosingCertificate: string = GeneralMessageModel.TXT_BUTTON_ACCEPT_DELETE_GENERATED_CLOSING_CERTIFICATE;
	txtButtonDeclineDeleteGeneratedClosingCertificate: string = GeneralMessageModel.TXT_BUTTON_DECLINE_DELETE_GENERATED_CLOSING_CERTIFICATE;
	txtButtonCloseDialog: string = GeneralMessageModel.TXT_CLOSE_DIALOG;
	txtButtonDeclineDeleteTagAlert: string = GeneralMessageModel.TXT_BUTTON_DECLINE_DELETE_TAG_ALERT;
	txtButtonAcceptDeleteTagAlert: string = GeneralMessageModel.TXT_BUTTON_ACCEPT_DELETE_TAG_ALERT;
	txtButtonCCAldImportMassiveContractChangePageConfirm: string = GeneralMessageModel.TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_CONFIRM;
	txtButtonCCAldImportMassiveContractChangePageAnnul: string = GeneralMessageModel.TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_ANNUL;

	txtButtonGeneralViewAttachmentsDelete: string = GeneralMessageModel.TXT_BUTTON_GENERAL_VIEW_ATTACHMENTS_DELETE;

	txtButtonConfirmChangeTypePractice: string = GeneralMessageModel.TXT_BUTTON_CONFIRM_CHANGE_TYPE_PRACTICE;

	txtButtonCCSuspendSurveyOK: string = GeneralMessageModel.TXT_BUTTON_CC_SUSPEND_SURVEY_OK;

	txtButtonCCSpoConfirmTerminationContractOK: string = GeneralMessageModel.TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_OK;
	txtButtonCCSpoConfirmTerminationContractKO: string = GeneralMessageModel.TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_KO;

	txtButtonOK: string = GeneralMessageModel.TXT_BUTTON_OK;
	txtButtonCANCEL: string = GeneralMessageModel.TXT_BUTTON_CANCEL;
	txtButtonDeleteEntity: string = GeneralMessageModel.DELETE_ENTITY;

	generalMessageDialog: GeneralMessageModel;
	txtContactTechnicalSupport: string = GeneralMessageModel.TXT_CONTACT_TECHNICAL_SUPPORT;
	can_compile_insurance: boolean;

	fb: FormBuilder;

	now: Date = null;
	insuranceForm: FormGroup;
	calendarHeader: typeof CalendarHeaderComponent = CalendarHeaderComponent;
	translateContext = TranslateContext;

	constructor(
		public dialogRef: MatDialogRef<GeneralMessageDialogComponent>,
		private injector: Injector
	) {
	}


	ngOnInit(): void {
		if (this.can_compile_insurance) {
			this.fb = this.injector.get(FormBuilder);

			this.insuranceForm = this.fb.group(
				{
					date_insurance_expiration: ['', [Validators.required]],
					txt_insurance_number: ['', [Validators.required]],
					txt_insurance_notes: ['']
				}
			);
			this.now = new Date();
		}
	}

	onClick(action: any): void {
		if (!Utilities.isVoid(this.generalMessageDialog.link_button)) {
			Utilities.redirectToUri(this.generalMessageDialog.link_button);
			this.dialogRef.close(GeneralMessageDialogComponent.CLOSE_BY_CTA);
		} else {
			if (!Utilities.isVoid(action)) {
				this.dialogRef.close(action);
			} else {
				const splittedDate: string[] = this.can_compile_insurance ? DateUtilities.getStringDateFromDate(this.insuranceForm.get('date_insurance_expiration').value).split('-'): null;
				const requestBody: any = this.can_compile_insurance ?  {
					txt_insurance_number: this.insuranceForm.get('txt_insurance_number').value,
					txt_insurance_notes: this.insuranceForm.get('txt_insurance_notes').value,
					date_insurance_expiration: `${splittedDate[2]}/${splittedDate[1]}/${splittedDate[0]}`,
				} : null;
				this.dialogRef.close(this.can_compile_insurance && !!requestBody ? requestBody : GeneralMessageDialogComponent.CLOSE_BY_CTA);
			}
		}
	}
}

export class GeneralMessageModel {
	static MESSAGE_TYPE_1: number = 1;
	static MESSAGE_TYPE_2: number = 2;
	static MESSAGE_TYPE_3: number = 3;

	static BUTTON_STYLE_RAISED: string = 'raised';
	static BUTTON_STYLE_REVERSE: string = 'reverse';


	static TITLE_WARNING: string = 'TITLE_WARNING';
	static TITLE_WARNING_DELETE_TAG_ALERT: string = 'TITLE_WARNING_DELETE_TAG_ALERT';
	static TITLE_CAN_NOT_DELIVERY: string = 'TITLE_CAN_NOT_DELIVERY';
	static TITLE_CREATING_CERTIFICATE: string = 'TITLE_CREATING_CERTIFICATE';
	static TITLE_RELEASES_FEEDBACK: string = 'TITLE_RELEASES_FEEDBACK';
	static TITLE_CC_ALD_IMPORT_MASSIVE_CONTRACT_CHANGE_PAGE: string = 'TITLE_CC_ALD_IMPORT_MASSIVE_CONTRACT_CHANGE_PAGE';

	static TXT_AUTOMATIC_MESSAGE_WARNING: string = 'TXT_AUTOMATIC_MESSAGE_WARNING';
	static TXT_CREATING_CERTIFICATE: string = 'TXT_CREATING_CERTIFICATE';
	static TXT_RELEASES_FEEDBACK: string = 'TXT_RELEASES_FEEDBACK';
	static TXT_BACKEND_MESSAGES: string = 'TXT_BACKEND_MESSAGES';
	static TXT_DELETE_GENERATED_DELIVERY_CERTIFICATE: string = 'TXT_DELETE_GENERATED_DELIVERY_CERTIFICATE';
	static TXT_DELETE_GENERATED_CLOSING_CERTIFICATE: string = 'TXT_DELETE_GENERATED_CLOSING_CERTIFICATE';
	static TXT_IS_NOT_IR: string = 'TXT_IS_NOT_IR';
	static TXT_DELETE_TAG_ALERT: string = 'TXT_DELETE_TAG_ALERT';
	static TXT_CC_ALD_IMPORT_MASSIVE_CONTRACT_CHANGE_PAGE: string = 'TXT_CC_ALD_IMPORT_MASSIVE_CONTRACT_CHANGE_PAGE';
	static TXT_DELETE_ENTITY: string = 'TXT_DELETE_ENTITY';
	static TXT_CONFIRM_CENTER: string = 'TXT_CONFIRM_CENTER';

	static TXT_CC_SP_START_REPORT_SPOT: string = 'TXT_CC_SP_START_REPORT_SPOT';

	static TXT_AUTHORITY_ADD_ACCEPTANCE_REPORT: string = 'TXT_AUTHORITY_ADD_ACCEPTANCE_REPORT';
	static TXT_AUTHORITY_CANT_REMOVE_ACCEPTANCE_REPORT: string = 'TXT_AUTHORITY_CANT_REMOVE_ACCEPTANCE_REPORT';
	static TXT_ATTACHMENTS_CONFIRM_DELETE: string = 'TXT_ATTACHMENTS_CONFIRM_DELETE';

	static TXT_CC_SP_CHANGE_TAB: string = 'TXT_CC_SP_CHANGE_TAB';
	static TXT_CC_DKO_DELETE_DAMAGE: string = 'TXT_CC_DKO_DELETE_DAMAGE';
	static TXT_CC_SUSPEND_SURVEY: string = 'TXT_CC_SUSPEND_SURVEY';
	static TXT_CC_SPO_CONFIRM_TERMINATION_CONTRACT: string = 'TXT_CC_SPO_CONFIRM_TERMINATION_CONTRACT';
	static TXT_CC_DKO_CHANGE_NUM_TYRES: string = 'TXT_CC_DKO_CHANGE_NUM_TYRES';
	static TXT_BUTTON_GO_TO_ALERT: string = 'TXT_BUTTON_GO_TO_ALERT';
	static TXT_BUTTON_GO_TO_ORDER: string = 'TXT_BUTTON_GO_TO_ORDER';
	static TXT_BUTTON_SAVE_AND_GO_TO_ORDER: string = 'TXT_BUTTON_SAVE_AND_GO_TO_ORDER';
	static TXT_BUTTON_BLOCK_CREATING_CERTIFICATE: string = 'TXT_BUTTON_BLOCK_CREATING_CERTIFICATE';
	static TXT_BUTTON_FEEDBACK: string = 'TXT_BUTTON_FEEDBACK';
	static TXT_BUTTON_ACCEPT_DELETE_GENERATED_DELIVERY_CERTIFICATE: string = 'TXT_BUTTON_ACCEPT_DELETE_GENERATED_DELIVERY_CERTIFICATE';
	static TXT_BUTTON_DECLINE_DELETE_GENERATED_DELIVERY_CERTIFICATE: string = 'TXT_BUTTON_DECLINE_DELETE_GENERATED_DELIVERY_CERTIFICATE';
	static TXT_BUTTON_ACCEPT_DELETE_GENERATED_CLOSING_CERTIFICATE: string = 'TXT_BUTTON_ACCEPT_DELETE_GENERATED_CLOSING_CERTIFICATE';
	static TXT_BUTTON_DECLINE_DELETE_GENERATED_CLOSING_CERTIFICATE: string = 'TXT_BUTTON_DECLINE_DELETE_GENERATED_CLOSING_CERTIFICATE';
	static TXT_BUTTON_DECLINE_DELETE_TAG_ALERT: string = 'TXT_BUTTON_DECLINE_DELETE_TAG_ALERT';
	static TXT_BUTTON_ACCEPT_DELETE_TAG_ALERT: string = 'TXT_BUTTON_ACCEPT_DELETE_TAG_ALERT';

	static TXT_BUTTON_CC_SUSPEND_SURVEY_OK: string = 'TXT_BUTTON_CC_SUSPEND_SURVEY_OK';

	static TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_OK: string = 'TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_OK';
	static TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_KO: string = 'TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_KO';

	static TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_CONFIRM: string = 'TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_CONFIRM';
	static TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_ANNUL: string = 'TXT_BUTTON_CC_SPO_CONFIRM_TERMINATION_CONTRACT_ANNUL';

	static TXT_BUTTON_GENERAL_VIEW_ATTACHMENTS_DELETE: string = 'TXT_BUTTON_GENERAL_VIEW_ATTACHMENTS_DELETE';

	static TXT_BUTTON_CONFIRM_CHANGE_TYPE_PRACTICE: string = 'TXT_BUTTON_CONFIRM_CHANGE_TYPE_PRACTICE';

	static TXT_CLOSE_DIALOG: string = 'TXT_CLOSE_DIALOG';

	static TXT_CONTACT_TECHNICAL_SUPPORT: string = 'TXT_CONTACT_TECHNICAL_SUPPORT';
	static DELETE_ENTITY: string = 'DELETE_ENTITY';

	static TXT_BUTTON_OK: string = 'TXT_BUTTON_OK';
	static TXT_BUTTON_CANCEL: string = 'TXT_BUTTON_CANCEL';

	title: string;
	txts: string[] = [];
	buttons: any[] = [];
	showCloseButton: boolean;
	type: number;
	link_button?: string;
	params: any[];

	constructor(obj?: any) {

		if (!Utilities.isEmpty(obj)) {
			Object.assign(this, obj);
		}
	}
}
